import { useTogglePreview } from 'src/hooks';
import { useDataContext } from 'src/contexts';
import { usePreventScroll } from 'src/hooks/use-prevent-scroll';

export function useMediaPreview() {
  const data = useDataContext((ctx) => ctx.pvoData.files?.[0]);

  const { isPreview, togglePreview } = useTogglePreview();

  usePreventScroll(isPreview);

  const handleClose = () => {
    togglePreview();
  };

  return {
    data,
    show: isPreview,
    handleClose,
  };
}
